export const LANGUAGE_LABELS: Record<string, string> = {
  de: "Deutsch",
  en: "English",
  es: "Español",
  fr: "Français",
  it: "Italiano",
  pt: "Português",
  nl: "Nederlands",
  pl: "Polski",
  tr: "Türkçe",
  ar: "العربية",
  ru: "Русский",
  ja: "日本語",
  ko: "한국어",
  zh: "中文",
  sonstige: "Sonstige",
};

export const LINK_TYPE_LABELS: Record<string, string> = {
  website: "Website",
  spotify: "Spotify",
  apple_podcasts: "Apple Podcasts",
  youtube: "YouTube",
  instagram: "Instagram",
  tiktok: "TikTok",
  twitter: "X / Twitter",
  linkedin: "LinkedIn",
  sonstige: "Sonstige",
};

export const MEDIUM_TYPE_LABELS: Record<string, string> = {
  youtube: "YouTube",
  podcast: "Podcast",
  instagram: "Instagram",
  tiktok: "TikTok",
  linkedin: "LinkedIn",
  blog: "Blog",
  newsletter: "Newsletter",
  tv: "TV",
  website: "Website",
  sonstige: "Sonstiges",
};

export const SHOW_STATUS_LABELS: Record<string, string> = {
  aktiv: "Aktiv",
  coming_soon: "Coming Soon",
  pausiert: "Pausiert",
};

export const APPLICATION_STATUS_LABELS: Record<string, string> = {
  offen: "Offen",
  angenommen: "Angenommen",
  abgelehnt: "Abgelehnt",
  zurueckgezogen: "Zurückgezogen",
};
